import axios from 'axios'

const API_BASE = process.env.REACT_APP_NEXTERA_API

export interface InspectionToolAnnotationResponse {
  confidence_applied: number | null
  excluded_labels_applied: string[]
  filtered_annotations_count: number
  filtered_annotations: Record<string, unknown>[]
  ml_response: Record<string, unknown>
  annotated_image_base64: string
}

export interface InspectionToolXRayResponse {
  xray_image_base64: string
  image_format: string
}

export interface InspectionImageImportJobStatusResponse {
  job_id: string
  status: 'queued' | 'running' | 'success' | 'failed'
  summary?: Record<string, unknown>
  errors?: string[]
  warnings?: string[]
}

export const runInspectionToolPreview = async (params: {
  imageFile: File
  confidence?: number | null
  excludedLabels?: string[]
}): Promise<InspectionToolAnnotationResponse> => {
  const formData = new FormData()
  formData.append('image', params.imageFile)

  if (typeof params.confidence === 'number') {
    formData.append('confidence', params.confidence.toString())
  }

  if (params.excludedLabels?.length) {
    formData.append('excluded_labels_csv', params.excludedLabels.join(','))
  }

  const response = await axios.post(
    `${API_BASE}/users/inspection-tools-annotate`,
    formData,
  )

  return response.data.data ?? response.data
}

export const generateInspectionXRay = async (params: {
  rgbFile: File
  uvFile: File
}): Promise<InspectionToolXRayResponse> => {
  const formData = new FormData()
  formData.append('rgb_image', params.rgbFile)
  formData.append('uv_image', params.uvFile)

  const response = await axios.post(
    `${API_BASE}/users/inspection-tools-xray`,
    formData,
  )

  return response.data.data ?? response.data
}

export const startInspectionImportJob = async (params: {
  projectId: string
  missionId: number
  viewpointId?: number
  skipExisting?: boolean
  dryRun?: boolean
  files: File[]
}): Promise<InspectionImageImportJobStatusResponse> => {
  const formData = new FormData()
  formData.append('project_id', params.projectId)
  formData.append('mission_id', params.missionId.toString())

  if (typeof params.viewpointId === 'number') {
    formData.append('viewpoint_id', params.viewpointId.toString())
  }
  formData.append('skip_existing', String(Boolean(params.skipExisting)))
  formData.append('dry_run', String(Boolean(params.dryRun)))
  params.files.forEach(file => formData.append('images', file))

  const response = await axios.post(
    `${API_BASE}/users/inspection-tools-import`,
    formData,
  )
  return response.data.data ?? response.data
}

export const getInspectionImportStatus = async (
  jobId: string,
): Promise<InspectionImageImportJobStatusResponse> => {
  const response = await axios.get(
    `${API_BASE}/users/inspection-tools-import-status/${jobId}`,
  )
  return response.data.data ?? response.data
}
